import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../assets/images/user/Group 1.png';
import searchIcon from '../../assets/images/user/Frame 2.png';
import chatIcon from '../../assets/images/user/fluent_chat-16-filled.png';
import scalesIcon from '../../assets/images/user/ph_scales-fill.png';
import messageIcon from '../../assets/images/user/lets-icons_message.png';
import userIcon from '../../assets/images/user/solar_user-bold.png';
// About icon - using a standard info icon
import aboutIcon from '../../assets/images/user/info-circle.svg';
// Home icon
import homeIcon from '../../assets/images/user/home-icon.svg';
import { LuBrain } from 'react-icons/lu';
import LogoutModal from '../LogoutModal';
import { useAuth } from '../../contexts/AuthContext';

const AppSidebar = ({ 
  userType = 'user', // 'user' or 'lawyer'
  onNavigateToUserPage = null,
  isMenuOpen = false,
  setIsMenuOpen = () => {}
}) => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [showProfileDropdown, setShowProfileDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const modalRef = useRef(null);
  const { user } = useAuth();
  const navigate = useNavigate();

  // Define the base class name based on user type
  const baseClass = userType === 'lawyer' ? 'lawyer-profile-page' : 'user-page';

  // Handle clicks outside of the dropdown
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowProfileDropdown(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogoutClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowProfileDropdown(false);
    setShowLogoutModal(true);
  };

  const handleProfileClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowProfileDropdown(false);
    navigate('/profile');
  };

  // Logo click handler for lawyer profile
  const handleLogoClick = () => {
    if (userType === 'lawyer' && onNavigateToUserPage) {
      onNavigateToUserPage();
    }
  };

  // Search icon handler for lawyer profile
  const handleSearchClick = () => {
    if (userType === 'lawyer' && onNavigateToUserPage) {
      onNavigateToUserPage();
    }
  };

  return (
    <aside className={`${baseClass}__sidebar`}>
      <div className={`${baseClass}__logo`}>
        <Link to="/">
          <img src={logo} alt="Zahoot Logo" />
        </Link>
      </div>
      
      <div className={`${baseClass}__nav-items`}>
        {/* Home icon */}
        <Link to="/" className={`${baseClass}__nav-item`} data-tooltip="Home">
          <img src={homeIcon} alt="Home" />
        </Link>
        
        {userType === 'lawyer' ? (
          <div
            className={`${baseClass}__nav-item active`}
            data-tooltip="Search Directory"
            onClick={handleSearchClick}
            style={{ cursor: 'pointer' }}
          >
            <img src={searchIcon} alt="Search" />
          </div>
        ) : (
          <Link to="/search" className={`${baseClass}__nav-item`} data-tooltip="Search Directory">
            <img src={searchIcon} alt="Search" />
          </Link>
        )}
        
        <Link to="/ask-a-question" className={`${baseClass}__nav-item`} data-tooltip="Ask a Legal Question">
          <img src={chatIcon} alt="Chat" />
        </Link>
        
        <Link to="/legal-services" className={`${baseClass}__nav-item`} data-tooltip="Legal Services">
          <img src={scalesIcon} alt="Legal" />
        </Link>
        
        <Link to="/contact" className={`${baseClass}__nav-item`} data-tooltip="Contact Us">
          <img src={messageIcon} alt="Messages" />
        </Link>
        
        {/* New About icon */}
        <Link to="/about" className={`${baseClass}__nav-item`} data-tooltip="About">
          <img src={aboutIcon} alt="About" />
        </Link>

        {/* LegalBrain */}
        <a
          href="https://legalbrain.zahoot.ai"
          className={`${baseClass}__nav-item`}
          data-tooltip="LegalBrain"
        >
          <span
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 32,
              height: 32,
              borderRadius: 9,
              background: 'linear-gradient(135deg, #D80364 0%, #F0654B 100%)'
            }}
          >
            <LuBrain size={22} color="#ffffff" />
          </span>
        </a>
      </div>
      
      <div className={`${baseClass}__bottom-nav`}>
        {user && (
          <div className={`${baseClass}__profile-container ${showProfileDropdown ? 'dropdown-open' : ''}`} ref={dropdownRef}>
            {userType === 'lawyer' ? (
              <div 
                className={`${baseClass}__nav-item profile-button`} 
                data-tooltip="Profile"
                onClick={() => setShowProfileDropdown(!showProfileDropdown)}
                style={{ cursor: 'pointer' }}
              >
                <img src={userIcon} alt="Account" />
              </div>
            ) : (
              <button 
                className={`${baseClass}__nav-item profile-button`} 
                data-tooltip="Profile"
                onClick={() => setShowProfileDropdown(!showProfileDropdown)}
              >
                <img src={userIcon} alt="Profile" />
              </button>
            )}
            
            {/* Profile Dropdown */}
            {showProfileDropdown && (
              <div className={`${baseClass}__profile-dropdown`}>
                <ul>
                  <li onClick={handleProfileClick}>
                    My Profile
                  </li>
                  <li onClick={handleLogoutClick}>
                    Logout
                  </li>
                </ul>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Logout Modal */}
      <LogoutModal 
        isOpen={showLogoutModal} 
        onClose={() => setShowLogoutModal(false)} 
      />
    </aside>
  );
};

export default AppSidebar; 